export default "__VITE_ASSET__243cf18f__"